<div [ngClass]="{'general-loading': _loading.isLoading }" *blockUI="'componentsPrivateLayout'; message: null">
	<app-header-nav *ngIf="!isPortalClienteRoute"></app-header-nav>

	<!-- Un solo outlet. Si se crea y se destruye al cambiar de cara, la
	     vuelta a la clásica (Services ya cargado) se activa en el outlet
	     que acaba de morir y la pantalla queda en blanco. -->
	<div class="private-outlet" [class.suite-shell]="showSuiteSidebar">
		@if (showSuiteSidebar) {
			<aside class="suite-shell__sidebar" [class.is-collapsed]="menuColapsado">
				<button type="button" class="suite-shell__toggle" (click)="alternarMenu()"
					aria-controls="suite-shell-menu" [attr.aria-expanded]="!menuColapsado"
					[attr.aria-label]="menuColapsado ? 'Mostrar menú' : 'Ocultar menú'"
					[title]="menuColapsado ? 'Mostrar menú' : 'Ocultar menú'">
					<i class="fas fa-angle-double-left" [class.rtte]="menuColapsado" aria-hidden="true"></i>
				</button>
				<div id="suite-shell-menu" class="suite-shell__menu" [attr.inert]="menuColapsado ? '' : null">
					<app-suite-modules></app-suite-modules>
				</div>
			</aside>
		}
		<div class="private-outlet__content" [class.suite-shell__content]="showSuiteSidebar">
			<router-outlet></router-outlet>
		</div>
	</div>
</div>
